import React from 'react';
import { useModalStore } from '../../stores/useUIStore';
import apiClient from '../../api/api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const AdminEventDetailsModal = ({ events, date, onEventsUpdated }) => {
  const closeModal = useModalStore((state) => state.closeModal);
  const openModal = useModalStore((state) => state.openModal);

  const handleEdit = (event) => {
    closeModal(); // Cerramos el modal actual
    openModal('createAdminEvent', {
      eventToEdit: event,
      onEventCreated: onEventsUpdated, // Reutilizamos el callback
    });
  };

  const handleDelete = async (eventId) => {
    if (window.confirm('¿Estás seguro de que quieres eliminar este evento?')) {
      try {
        await apiClient.delete(`/admin/events/${eventId}`);
        toast.success('Evento eliminado.');
        onEventsUpdated();
        closeModal();
      } catch (error) {
        toast.error('No se pudo eliminar el evento.');
      }
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-xl w-full max-w-md">
      <h2 className="text-2xl font-bold mb-2 text-gray-800">
        Eventos del {format(date, "d 'de' MMMM", { locale: es })}
      </h2>
      <div className="space-y-4 mt-6 max-h-80 overflow-y-auto">
        {events.map((event) => (
          <div key={event._id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <div className="flex items-center">
              <span
                className="w-3 h-3 rounded-full mr-3"
                style={{ backgroundColor: event.color }}
              ></span>
              <p className="text-gray-800">{event.title}</p>
            </div>
            <div className="flex space-x-3">
              <button onClick={() => handleEdit(event)} className="text-gray-500 hover:text-blue-600" title="Editar">
                <i className="fas fa-edit"></i>
              </button>
              <button onClick={() => handleDelete(event._id)} className="text-gray-500 hover:text-red-600" title="Eliminar">
                <i className="fas fa-trash"></i>
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-end mt-6">
        <button
          onClick={closeModal}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default AdminEventDetailsModal;